<template>
  <div class="modules-navigation-box flex-center" :class="{'minor': nbMinorName}">
    <router-link class="module flex-center"
                 v-for="(module, index) in nbModules"
                 @click.native.stop="activeNavigations(module.id)"
                 :to="getUrls(module.id)"
                 :key="index"
                 tag="div"
                 :class="{'active': $store.state.activeModule
                 ? module.id === $store.state.activeModule.id : false}"
                 active-class="active">
      {{module.translationKey | translate}}
    </router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { findObject } from '../utility';
import EventBus from '@/store/EventBus';

export default {
  name: 'ModulesNavigationBox',
  props: [
    'nbModules',
    'nbNavigationName',
    'nbMinorActive',
    'nbMinorName',
    'nbType', // if edit
  ],
  computed: {
    ...mapGetters([
      'activeModules',
      'activeMinorModule',
    ]),
  },
  methods: {
    ...mapActions([
      'setActiveModules',
      'setActiveMinorModule',
      'set_mainTableHeaderDropdownData',
      'set_sidebarTableHeaderDropdownData',
      'setActiveFilters',
      'setSearchedFilter',
      'resetDateTime',
    ]),
    getUrls(id) {
      return !this.nbMinorName ? `/${this.nbNavigationName}/${id}` : `/${this.nbNavigationName}/${this.nbMinorName}/${id}`;
    },
    activeNavigations(id) {
      this.resetDateTime();
      this.setSearchedFilter({ value: null, type: 'reset' });
      this.setActiveFilters({});
      this.set_mainTableHeaderDropdownData();
      this.set_sidebarTableHeaderDropdownData();
      // eslint-disable-next-line no-unused-expressions
      !this.nbMinorName ? this.setActiveModules(id) : this.setActiveMinorModule(id);
    },
  },
  mounted() {
    // eslint-disable-next-line no-unused-expressions
    if (this.$route.matched.length > 2 && this.nbType !== 'edit') {
      const activeModulesId = this.$route.path.split('/')[2];
      const activeModules = findObject(this.$store.state.modules, activeModulesId);
      let activated = false;
      if (!this.activeModules) {
        this.setActiveModules(activeModulesId);
        activated = true;
      }
      if (!activeModules.submodule.length) {
        if (!activated) { this.setActiveModules(this.$route.params.id); }
      } else {
        this.setActiveMinorModule(this.$route.params.id);
      }
    }
    EventBus.$on('resetActiveModule', (event) => {
      this.activeNavigations(event);
    });
  },
};
</script>

<style lang="scss" scoped>
  .modules-navigation-box {
    background-color: #2e3743;
    font-size: 14px;
    height: 50px;
    .module {
      color: rgba(255, 255, 255, .5);
      cursor: pointer;
      height: 100%;
      padding: 0 20px;
      position: relative;
      &.active {
        color: #fff;
        &:before {
          width: 100%;
          left: 0;
          background-color: #009aff;
        }
      }
      &:before {
        transition: all .5s;
        content: "";
        position: absolute;
        top: 0;
        left: 30%;
        width: 40%;
        height: 3px;
        background-color: transparent;
      }
    }
    &.minor {
      background-color: transparent;
      box-shadow: inset 0 -1px 0 0 #d3dadd;
      margin-bottom: 10px;
      .module {
        color: #808b9c;
        &.active {
          color: #009aff;
        }
        &:before {
          bottom: 0;
          top: auto;
        }
      }
    }
    > div {
      text-transform: capitalize;
    }
  }
</style>
